import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Typography, Grid, Card, CardContent, CardActionArea, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Navbar } from '../../component/shared/Navbar'
import { PageContainer } from '../../component/styled/PageContainer'
import PeopleIcon from '@mui/icons-material/People'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import StarsIcon from '@mui/icons-material/Stars'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import BarChartIcon from '@mui/icons-material/BarChart'

const modules = [
  {
    title: 'Recipient',
    description: 'Manage sales representative details.',
    path: '/sales-recipient',
    icon: <PeopleIcon fontSize='large' color='primary' />
  },
  {
    title: 'Commission',
    description: 'Manage sales commissions.',
    path: '/sales-commission',
    icon: <ReceiptLongIcon fontSize='large' color='primary' />
  },
  {
    title: 'Incentive',
    description: 'Manage incentives and bonuses.',
    path: '/sales-incentive',
    icon: <StarsIcon fontSize='large' color='primary' />
  },
  {
    title: 'Payout',
    description: 'Manage payouts and payment summaries.',
    path: '/sales-payout',
    icon: <AccountBalanceWalletIcon fontSize='large' color='primary' />
  },
  {
    title: 'Visualization',
    description: 'Analytics dashboard for commissions and incentives.',
    path: '/sales-visualization',
    icon: <BarChartIcon fontSize='large' color='primary' />
  }
]

export const SalesCommissionIncentiveHub = () => {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>Commission Incentive Hub</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box sx={{ py: 5 }}>
          <Typography variant='h4' fontWeight='bold' gutterBottom>
            Commission Incentive Hub
          </Typography>
          <Typography variant='body1' color='text.secondary' mb={4}>
            Manage commissions, incentives, payouts, and recipients.
          </Typography>
          <Grid container spacing={3}>
            {modules.map((module) => (
              <Grid item xs={12} sm={6} md={4} key={module.path}>
                <Card
                  sx={{
                    height: '100%',
                    borderRadius: 3,
                    transition: '0.2s',
                    '&:hover': {
                      boxShadow: 6,
                      transform: 'translateY(-4px)'
                    }
                  }}
                >
                  <CardActionArea onClick={() => navigate(module.path)} sx={{ height: '100%' }}>
                    <CardContent>
                      <Box mb={2}>{module.icon}</Box>
                      <Typography variant='h6' fontWeight='bold' gutterBottom>
                        {module.title}
                      </Typography>
                      <Typography variant='body2' color='text.secondary'>
                        {module.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </PageContainer>
    </>
  )
}
